export default __webpack_public_path__ + "static/media/login-bg1.933c61cd.png";